import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Link } from 'basic-components/icons';

import { basicCustomInsightConsts } from 'actions/modules/insight';
import { customInsightSelectors } from 'selectors/modules/insight/custom';

import './ConnectionBox.scss';

const getAction = ({ connectionType, id }) => {
  switch(connectionType) {
    default:
    case basicCustomInsightConsts.CONNECTION_TYPES.ACTION: {
      return {
        icon: (
          <Link
              color="blue-bright"
              height={12}
              width={12}
          />
        ),
        onClick:() => {
          document.getElementById(id)?.scrollIntoView()
        }
      }
    }
  }
}

const { getInsightContent } = customInsightSelectors
const ConnectionBox = ({ label = "", connectionType, id = undefined, width = undefined, tile = undefined }) => {
  const reduxId = useSelector(state => getInsightContent(state).tiles.find(rawTile => rawTile.title === tile)?.id),
        localId = id || reduxId,
        { icon, onClick } = useMemo(() => getAction({ connectionType, id: localId }), [connectionType, localId])
  return (
    <div 
        className="insight-node-widget__connection"
        onClick={onClick}
        style={{ width }}
    >
      <div className="insight-node-widget__connection__content">
        <div className="insight-node-widget__connection__content__text">
          <p className="insight-node-widget__connection__content__text__main">
            {label}
          </p>
        </div>
        <div className="insight-node-widget__connection__content__action">
          {icon}
        </div>
      </div>
    </div>
  )
}

ConnectionBox.propTypes = {
  connectionType: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  tile: PropTypes.string,
  width: PropTypes.string,
}

export default ConnectionBox;